"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgScreenShareFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M5.932 9.279a3.174 3.174 0 002.898.867v3.666c0 .682.17 1.584.886 2.3.715.717 1.615.888 2.295.888.68 0 1.58-.171 2.295-.888.716-.716.887-1.618.887-2.3v-3.684a3.174 3.174 0 002.875-.872 3.192 3.192 0 000-4.507L17.321 4H20a2 2 0 012 2v10a2 2 0 01-2 2h-5l1 2.004h1c.667 0 1 .332 1 .998 0 .665-.333.998-1 .998H7c-.667 0-1-.333-1-.998 0-.666.333-.998 1-.998h1L9 18H4a2 2 0 01-2-2V6a2 2 0 012-2h2.701l-.77.771a3.192 3.192 0 000 4.508z' }),
    react_1.default.createElement("path", { d: 'M13.098 13.917V5.698l2.047 2.04a1.089 1.089 0 001.537 0 1.08 1.08 0 000-1.53l-3.902-3.89a1.088 1.088 0 00-1.537 0L7.318 6.23a1.08 1.08 0 000 1.532 1.089 1.089 0 001.537 0l2.07-2.064v8.219c0 .722.362 1.083 1.086 1.083.725 0 1.087-.36 1.087-1.083z' }))); };
exports.default = SvgScreenShareFilled;
//# sourceMappingURL=ScreenShareFilled.js.map